import { AssembleiaStatus } from "enuns/AssembleiaStatus";
import { AssembleiaPautaStatus } from "enuns/AssembleiaPautaStatus";
import { WSAssembleiasActionTypes, WS_ASSEMBLEIAS_ACTIONS_OPEN, WS_ASSEMBLEIAS_ACTIONS_ON_MESSAGE, WS_ASSEMBLEIAS_ACTIONS_CLOSE, WS_ASSEMBLEIAS_ACTIONS_ON_ERROR, WS_ASSEMBLEIAS_ACTIONS_MANUAL_REFRESH } from 'store/modules/WSAssembleiasActionTypes';

export interface Messenger {
  cpf: string;
  duvida: string;
  flgDestaque: boolean;
  flgPublica: boolean;
  idDuvidaFrequente: number;
  nomePessoaComentario: string;
  resposta: string;
  dataPergunta: string;
}

export interface IWSAssembleia {
  id: number;
  idPauta?: number;
  needLoadList?: boolean;
  needLoadPautas?: boolean;
  needLoadContas?: boolean;
  needLoadAssembleia?: boolean;
  isChatAtivo: boolean;
  pautas: [
    {
      idPauta: number;
      status: AssembleiaPautaStatus;
      tempoVotacao: number;
      tempoRestante: number;
      flgResultadoLiberado: boolean;
    }
  ];
  contasCapital?: number;
  usuariosLogados: number;
  presentes: number;
  status: AssembleiaStatus;
  messenger: Messenger | null;
}

export interface IWSAssembleiasReducer {
  opened: boolean,
  error: any,
  assembleiasChanges: {
    [key: number]: IWSAssembleia
  },
  manualRefreshDelayInSeconds: number,
  totalManualRefresh: number,
}

const INITIAL_STATE: IWSAssembleiasReducer = {
  opened: false,
  error: null,
  assembleiasChanges: {},
  manualRefreshDelayInSeconds: 45,
  totalManualRefresh: 0,
}

export default (state: IWSAssembleiasReducer = INITIAL_STATE, action: WSAssembleiasActionTypes): IWSAssembleiasReducer => {
  switch (action.type) {
    case WS_ASSEMBLEIAS_ACTIONS_MANUAL_REFRESH:
      return {
        ...state,
        totalManualRefresh: state.totalManualRefresh + 1
      }
    case WS_ASSEMBLEIAS_ACTIONS_OPEN:
      return {
        ...state,
        opened: true,
        error: INITIAL_STATE.error
      };
    case WS_ASSEMBLEIAS_ACTIONS_ON_MESSAGE:
      return {
        ...state,
        assembleiasChanges: {
          ...state.assembleiasChanges,
          [action.payload.id]: action.payload
        }
      };
    case WS_ASSEMBLEIAS_ACTIONS_CLOSE:
      return {
        ...state,
        opened: INITIAL_STATE.opened,
        error: INITIAL_STATE.error
      };
    case WS_ASSEMBLEIAS_ACTIONS_ON_ERROR:
      return {
        ...state,
        opened: INITIAL_STATE.opened,
        error:action.payload
      };
    default:
      return state;
  }
};